import restService from "../rest-service/RestService";
import { ISearchResultsModel } from "./Models";

type ObjectSearchQueryParams = {
    searchString: string
}
const ObjectSearchDataService = {

    getObjectSearchData: async function(contextGroupID: number, searchText: string, signal?: AbortSignal): Promise<ISearchResultsModel> {

        const queryParams: ObjectSearchQueryParams = {
            searchString: encodeURIComponent(searchText)
        };
        
        const response = await restService.get<ISearchResultsModel, ObjectSearchQueryParams>(`/groups/${contextGroupID}/objectsearch`, signal, queryParams);
        return response.data;

    }
};

export default ObjectSearchDataService;